import { IApp } from 'interfaces/navigationApp.interface'

import { AccessGroups } from 'enums/AccessGroups'

import { BotulismCustomPages } from './BotulismCustomPages'
import { BotulismMenu, BotulismSlugs } from './BotulismMenu'
import { BotulismPages } from './BotulismPages'

const BotulismApp: IApp<BotulismSlugs> = {
  name: 'Botulism',
  slug: 'botulism',
  endpoint: 'outbreak-botulism',
  accessGroups: [AccessGroups.Botulism],
  menu: BotulismMenu,
  customPages: BotulismCustomPages,
  pages: BotulismPages,
  appIdentifier: 'Botulism',
  createdAt: new Date(2022, 7, 11),
}

export default BotulismApp
